import { render, staticRenderFns } from "./ParentManage.vue?vue&type=template&id=69ced4a0"
import script from "./ParentManage.vue?vue&type=script&lang=js"
export * from "./ParentManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports